/* eslint-disable @typescript-eslint/no-explicit-any */
// reference: https://github.com/therealemjy/noop-ts
const noop = (...args: any[]): any => {
  // no operation
}

export default noop
